module.exports = __webpack_public_path__ + "static/img/zhuanli02.fe54288.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli02.png
// module id = vqfh
// module chunks = 1